import axios from "axios";
import config from "app/api/axiosConfig";

export default (token: string, id: number) =>
  axios.delete(
    `${process.env.REACT_APP_API_HOST}/admin/messages?id=${id}`,
    config(token)
  );
